import type { SelectableChannel } from './adapters'

export const canSelectChannel = ({
  channel,
  channels,
}: {
  channel: SelectableChannel
  channels: SelectableChannel[]
}): boolean => {
  // Skip disabled channels
  if (channel.isDisabled) {
    return false
  }

  // Skip already selected channels
  if (channels.some((c) => c.id === channel.id)) {
    return false
  }

  return true
}

export const shouldAutoSelectChannel = ({
  channel,
  channels,
}: {
  channel: SelectableChannel
  channels: SelectableChannel[]
}): boolean => {
  return canSelectChannel({ channel, channels })
}
